import Application from "../../Application";
import RoleTypesPresenter, {
  IRoleTypesPresenter
} from "../../presenter/roles/RoleTypesPresenter";
import GetRolesInteractor from "./GetRoleTypesInteractor";
import GetReportingTypesInteractor from "../reporting/GetReportingTypesInteractor";
import GetPositionTypesInteractor from "../position/GetPositionTypesInteractor";

export default class ShowRoleTypesInteractor {
  private application: Application;
  private output?: IRoleTypesPresenter;

  constructor(application) {
    this.application = application;
  }

  async getRoleTypes() {
    return this.application.container
      .resolve<GetRolesInteractor>("getRoleTypes")
      .execute();
  }

  async getReportingTypes() {
    return this.application.container
      .resolve<GetReportingTypesInteractor>("getReportingTypes")
      .execute();
  }

  async getPositionTypes() {
    return this.application.container
      .resolve<GetPositionTypesInteractor>("getPositionTypes")
      .execute();
  }

  execute() {
    this.output = RoleTypesPresenter({
      application: this.application,
      initialState: {
        roleTypes: [],
        reportingTypes: []
      }
    });

    this.getRoleTypes().then(
      roleTypes => this.output && this.output.setRoleTypes(roleTypes)
    );

    this.getReportingTypes().then(
      reportingTypes =>
        this.output && this.output.setReportingTypes(reportingTypes)
    );

    this.getPositionTypes().then(
      positionTypes =>
        this.output && this.output.setPositionTypes(positionTypes)
    );

    return this.output;
  }
}
